import React, { useState } from "react";
import useWishlist from "./useWishlist";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";

import AuthenticatedWishListCard from "./AuthenticatedWishListCard";
import Dashboard from "../../../pages/Dashboard/Dashboard";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import useCart from "../cart/useCart";

function Wishlist() {
  const [loadingItemId, setLoadingItemId] = useState(null);
  const {
    wishlistItems,
    isGettingWishlist,
    removeFromWishlistFn,
    isRemovingFromWishlist,
    clearWishlistFn,
  } = useWishlist(true);

  const {
    addItemToCartFn,
    isAddingItem,
    cartItems,
    isRemovingProduct,
    removeItemFromCartFn,
  } = useCart();

  // console.log("wishlist items: ", wishlistItems);

  // const {getOneProductFn} = useFetchProduct();
  if (isGettingWishlist) {
    return (
      <Dashboard>
        <div className="flex justify-center items-center min-h-[60vh]">
          <CustomLoading size="2rem" />
        </div>
      </Dashboard>
    );
  }

  return (
    <>
      <div className="container mx-auto px-4 py-2 md:py-8">
        <h1 className="text-3xl font-bold mb-2 md:mb-8">My Wishlist</h1>

        {!wishlistItems || wishlistItems?.length === 0 ? (
          <div className="text-center md:py-12">
            <h2 className="text-2xl font-semibold text-gray-600 mb-4">
              Your wishlist is empty
            </h2>
            <p className="text-gray-500 mb-6">
              Add items to your wishlist to see them here
            </p>
            <Link
              to="/"
              className="inline-block bg-[#DA0E1A] text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors text-lg"
            >
              Continue Shopping
            </Link>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {wishlistItems.length > 0 &&
                wishlistItems?.map((item) => (
                  <AuthenticatedWishListCard
                    key={item.productId}
                    item={item}
                    isAddingItem={isAddingItem}
                    loadingItemId={loadingItemId}
                    cartItems={cartItems}
                    isRemovingProduct={isRemovingProduct}
                    addItemToCartFn={addItemToCartFn}
                    removeItemFromCartFn={removeItemFromCartFn}
                    isRemovingFromWishlist={isRemovingFromWishlist}
                    removeFromWishlistFn={removeFromWishlistFn}
                    setLoadingItemId={setLoadingItemId}
                  />
                ))}
            </div>
            <div className="mt-8 flex justify-end">
              <button
                onClick={clearWishlistFn}
                className="bg-red-600 hover:bg-red-700 transition-colors rounded-lg py-2 px-4 text-lg text-white flex items-center gap-2"
              >
                Clear Wishlist
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                </svg>
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Wishlist;
